// function to get day differnece between two date
const dateDifference = (startDate: any, endDate: any) => {
    const date1 = new Date(startDate);
    const date2 = new Date(endDate);
    const timeDiff = Math.abs(date2.getTime() - date1.getTime());
    const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24)); 
    if(diffDays > 0) {
        
        return diffDays+" Days";
    }
    else {
        return "";
    }
}

export default dateDifference;


// WEBPACK FOOTER //
// ./src/helpers/dateDifference.ts